import { render } from "./InstituteDetailsComponent.vue?vue&type=template&id=509e30a4&scoped=true"
import script from "./InstituteDetailsComponent.vue?vue&type=script&lang=js"
export * from "./InstituteDetailsComponent.vue?vue&type=script&lang=js"

import "./InstituteDetailsComponent.vue?vue&type=style&index=0&id=509e30a4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-509e30a4"

export default script